import './searchBar.scss';

import React, { useEffect, useMemo, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import SearchIcon from './SearchIcon';
import SearchList from './SearchList';
import { debounce } from 'lodash';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';
import useMobileDetect from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Hooks/useMobileDetect';

export default function SearchBar(props: { searchIcon: string }) {
    const { t } = useTranslation('pages');
    const { navigateTranslated } = usePageLocalization();
    const isMobile = useMobileDetect().isMobile();

    const [searchTerms, setSearchTerms] = useState('');
    const [isSearchListOpen, setSearchListOpen] = useState(false);
    const [showSearchBar, setShowSearchBar] = useState(false);

    const [localsearchAddress, setLocalSearchAddress] = useState(searchTerms);
    const searchTermsDelay = useMemo(() => debounce(setSearchTerms, 800), []);

    const queryResult = useStaticQuery(
        graphql`
            query SearchList {
                allProductsJson {
                    nodes {
                        code
                        title {
                            en_CA
                            en_US
                            fr_CA
                        }
                        slug {
                            en_CA
                            fr_CA
                            en_US
                        }
                        category
                        images
                        fields {
                            ...productsFieldsImagesFragment
                        }
                        attributes {
                            content_short {
                                values {
                                    en_CA
                                    en_US
                                    fr_CA
                                }
                            }
                            content {
                                name {
                                    en_CA
                                    en_US
                                    fr_CA
                                }
                                values {
                                    en_CA
                                    en_US
                                    fr_CA
                                }
                            }
                        }
                        parts {
                            code
                            attributes {
                                schema_number {
                                    values {
                                        en_CA
                                        en_US
                                        fr_CA
                                    }
                                }
                                nb_per_appliance {
                                    values {
                                        en_CA
                                        en_US
                                        fr_CA
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `
    );
    const allProducts = queryResult.allProductsJson.nodes;

    return (
        <>
            <SearchIcon
                d={props.searchIcon}
                className='search-icon-cls'
                id='search-icon-cls'
                viewbox='0 0 18.746 18.746'
                transform='translate(-4.5 -4.5)'
                onClick={(event: any) => {
                    if (isMobile) {
                        setShowSearchBar(!showSearchBar);
                    }
                    if (searchTerms.trim() !== '') {
                        navigateTranslated(
                            `/search/?q=${searchTerms}&limit=40&filter=NOT (category.en-CA.keyword: "/OCC/Parts/") AND NOT (category.en-CA.keyword: "/OCC/Options/")`
                        );
                    }
                }}
            />

            <div
                className={`search-input-box ${
                    showSearchBar ? 'show-search-bar-mobile' : ''
                }`}
            >
                <input
                    key='SearchInputTxtBox'
                    type='text'
                    className={`${
                        showSearchBar ? 'show-search-bar-mobile' : ''
                    }`}
                    value={localsearchAddress}
                    onChange={(event) => {
                        setLocalSearchAddress(event.target.value);
                        searchTermsDelay(event.target.value);
                        if (!isSearchListOpen) {
                            setSearchListOpen(true);
                        }
                    }}
                    onClick={() => {
                        if (!isSearchListOpen) {
                            setSearchListOpen(true);
                        }
                    }}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' && searchTerms !== '') {
                            navigateTranslated(
                                `/search/?q=${searchTerms}&limit=40&filter=NOT (category.en-CA.keyword: "/OCC/Parts/") AND NOT (category.en-CA.keyword: "/OCC/Options/")`
                            );
                        }
                    }}
                    onBlur={() => {
                        setTimeout(() => {
                            if (isSearchListOpen) {
                                setSearchListOpen(false);
                            }
                        }, 1000);
                    }}
                />
                {isSearchListOpen && searchTerms.length >= 2 && (
                    <SearchList
                        searchTerms={searchTerms}
                        isSearchListOpen={isSearchListOpen}
                        setSearchListOpen={setSearchListOpen}
                        allProducts={allProducts}
                        t={t}
                    />
                )}
            </div>
        </>
    );
}
